import React from "react";
import useGeoBlocked from "../../hooks/useGeoBlocked";

export default function PaymentButton({onClick, type = "button", className, style, children, disabled = false}) {
    const geoBlocked = useGeoBlocked();

    if (geoBlocked) {
        return (
            <button
                type="button"
                className={className}
                style={{...style, opacity: 0.5, cursor: 'not-allowed'}}
                disabled
            >
                Unavailable
            </button>
        );
    }

    return (
        <button
            type={type}
            onClick={onClick}
            className={className}
            style={style}
            disabled={disabled}
        >
            {children}
        </button>
    );
}
